import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.wayroot.app";

const RIDE_NOW_OPTIONS = [
  {
    title: "Auto",
    image: "/AutoImage.png",
  },
  {
    title: "E Rikshaw",
    image: "/ERikshawImage.png",
  },
  {
    title: "Van",
    image: "/VanImage.png",
  },
  {
    title: "Car",
    image: "/CarImage.png",
  },
];

export default function RideNow() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Header />

      <main className="bg-white">
        <section className="border-b border-slate-100">
          <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
            <div className="mx-auto max-w-3xl text-center">
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500">
                Wayroot App
              </p>
              <h1 className="mt-3 text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
                Ride Now for Immediate travel
              </h1>
              <p className="mt-5 text-lg leading-8 text-slate-600">
                Ride Now is available only on Wayroot App.
              </p>
              <p className="mt-2 text-base text-slate-500">
                Download the app now for instant travel.
              </p>

              <div className="mt-8 flex justify-center">
                <a
                  href={PLAY_STORE_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex min-h-[54px] items-center justify-center rounded-[18px] bg-[#0B0E13] px-6 py-3.5 text-sm font-bold text-white transition hover:bg-black"
                >
                  <span>Get it on Google Play</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 sm:py-16 lg:py-20">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
              <div>
                <h2 className="text-2xl font-bold tracking-tight text-slate-900">
                  4 vehicle types for Ride Now
                </h2>
                <p className="mt-2 text-sm text-slate-600">
                  Auto, E Rikshaw, Van and Car on the Wayroot app.
                </p>
              </div>
            </div>

            <div className="mt-8 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
              {RIDE_NOW_OPTIONS.map((option) => (
                <div
                  key={option.title}
                  className="overflow-hidden rounded-[24px] border border-slate-200 bg-white"
                >
                  <div className="aspect-[4/3] bg-slate-50">
                    <img
                      src={option.image}
                      alt={option.title}
                      className="h-full w-full object-cover"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                  <div className="border-t border-slate-100 px-5 py-4">
                    <h3 className="text-lg font-semibold text-slate-900">
                      {option.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 flex justify-center">
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noreferrer"
                className="inline-flex min-h-[52px] items-center justify-center rounded-[18px] border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-slate-900 transition hover:bg-slate-50"
              >
                Download the App
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
